// extracted by mini-css-extract-plugin
export default {"modal":"modal__modal___DJxFT","modalHeader":"modal__modalHeader___yUBZf","modalClose":"modal__modalClose___XZ33Z"};